/**
 * @generated SignedSource<<dc3be1e92e74720459febc069735bcbb>>
 * @relayHash c00b96648049e9ef06d4e799484ff848
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c00b96648049e9ef06d4e799484ff848

import { ConcreteRequest } from 'relay-runtime';
export type DeleteNewsInput = {
  id: string;
};
export type useDeleteNewsMutation$variables = {
  connections: ReadonlyArray<string>;
  deleteNews: DeleteNewsInput;
};
export type useDeleteNewsMutation$data = {
  readonly deleteNews: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly newsId?: number;
    }> | null;
    readonly news: {
      readonly id: string;
    } | null;
  };
};
export type useDeleteNewsMutation = {
  response: useDeleteNewsMutation$data;
  variables: useDeleteNewsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deleteNews"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "deleteNews"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newsId",
      "storageKey": null
    }
  ],
  "type": "NewsNotFound",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeleteNewsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "DeleteNewsPayload",
        "kind": "LinkedField",
        "name": "deleteNews",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "News",
            "kind": "LinkedField",
            "name": "news",
            "plural": false,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useDeleteNewsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "DeleteNewsPayload",
        "kind": "LinkedField",
        "name": "deleteNews",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "News",
            "kind": "LinkedField",
            "name": "news",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c00b96648049e9ef06d4e799484ff848",
    "metadata": {},
    "name": "useDeleteNewsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f6e7f9a1129f2796d959f38380456388";

export default node;
